export default __webpack_public_path__ + "static/media/gauravDahake.ef10b35f.png";